import { Link as RouterLink } from "react-router-dom";

// material-ui
import { Link, Stack, Typography } from "@mui/material";

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{ p: "24px 16px 0px", mt: "auto" }}
  >
    <Typography variant="caption">
      &copy; Created by Pi Incorporation
    </Typography>
    <Stack
      spacing={1.5}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Link
        component={RouterLink}
        to="https://guiview.com/privacy-notice"
        target="_blank"
        variant="caption"
        color="textPrimary"
      >
        Privacy Notice
      </Link>
      <Link
        component={RouterLink}
        to="https://guiview.com/return-refund-shipping"
        target="_blank"
        variant="caption"
        color="textPrimary"
      >
        Refund-Return-Shipping-Policy
      </Link>
      <Link
        component={RouterLink}
        to="https://guiview.com/term-of-use"
        target="_blank"
        variant="caption"
        color="textPrimary"
      >
        Terms of Use
      </Link>
      <Link
        component={RouterLink}
        to="https://guiview.com/data-protection-statement"
        target="_blank"
        variant="caption"
        color="textPrimary"
      >
        Data Protection
      </Link>
    </Stack>
  </Stack>
);

export default Footer;
